export const invoice_type_arr = [, "Rent", "Deposit", "Other", "Refund"];
export const pay_status_arr = [, "Unpaid", "Paid", "Cancelled", "Partial Paid"];
export const type_arr = [, "Cash", "Online"];
export const payment_type_arr = [, "Expense", "Income"];
export const unit_type_arr = [, "1 BHK", "2 BHK", "3 BHK", "Studio", "1RK"];
export const amenities_arr = [, "Furnished", "Semi-Furnished"];
export const unit_sta_arr = [, "Available", "Occupied"];
